import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getCurrent, getSteps} from './StepsReducers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Steps.css';
import {STEP_STATUS_CURRENT, STEP_STATUS_READY} from './StepsContants';
import { faCheckCircle, faCircle as farCircle, faDotCircle } from '@fortawesome/free-regular-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import {next, select} from './StepsActions';

const StepsContainer = ({steps, current, next, select}) => {

  function getIconByStep(step) {
    if (step.status === STEP_STATUS_READY) {
      return faCheckCircle;
    }
    if (step.status === STEP_STATUS_CURRENT) {
      return faDotCircle;
    }
    if (step.isAllowed) {
      return faDotCircle;
    }

    return farCircle;
  }

  const toggleBodyClass = (className) => {
    if (document.body.classList.contains(className)) {
      document.body.classList.remove(className);
    } else {
      document.body.classList.add(className);
    }
  };

  const toggleMenu = () => {
    const classNameToToggle = document.body.classList.contains('page-small') ? 'show-sidebar' : 'hide-sidebar';
    toggleBodyClass(classNameToToggle);
  };

  return (
    <nav className="steps-container">
      <div onClick={toggleMenu} className="header-link hide-menu toggle-btn">
        <FontAwesomeIcon icon={faBars}/>
        <span className={'step-in-menu ' + current.status}>
           {current.number}: {current.value}
        </span>
      </div>
      {steps.map((step, key) =>
        <div onClick={() => select(step)} key={key} className={'header-link hide-menu step ' + step.status}>
          <FontAwesomeIcon icon={getIconByStep(step)} /> STEP: {step.number}: {step.value}
        </div>
      )}
    </nav>
  );
};

StepsContainer.propTypes = {
  steps: PropTypes.array.isRequired,
  current: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  steps: getSteps(state),
  current: getCurrent(state)
});

export default connect(
  mapStateToProps,
  {next, select}
)(StepsContainer);


// WEBPACK FOOTER //
// ./src/steps/StepsContainer.js